import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IconButton } from '#src/atoms/buttons/IconButton/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';
import { ClaimRewards } from '#src/components/rewards/ClaimRewards/index.tsx';
import type { Reward } from '#src/components/rewards/types.ts';
import { laptopAndAbove } from '#src/style/mediaQuery.ts';

const FullSize = styled.div`
  height: 100%;
  @media ${laptopAndAbove} {
    height: calc(100vh - 4 * var(--unit));
  }
`;

const Actions = styled.div`
  position: absolute;
  right: var(--unit);
  top: var(--unit);
`;

type Props = {
  rewards: Reward[];
  open: boolean;
  onClaim: (id: string[]) => void;
  onClose: () => void;
  setSafeGoNextReward?: (cb: () => void) => void;
};

export const ClaimRewardsDialog = ({
  open,
  rewards,
  onClose,
  onClaim,
  setSafeGoNextReward,
}: Props) => {
  const { formatMessage } = useIntl();
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={false} hideHeader>
      <>
        <FullSize>
          <ClaimRewards
            rewards={rewards}
            onClaim={onClaim}
            setSafeGoNextReward={setSafeGoNextReward}
          />
        </FullSize>
        <Actions>
          <IconButton
            size="medium"
            onClick={onClose}
            color="tertiary"
            icon={faTimes}
            title={formatMessage({
              defaultMessage: 'Close rewards dialog',
            })}
          />
        </Actions>
      </>
    </Dialog>
  );
};
